<app-loader *ngIf="showLoader | async"></app-loader>
<router-outlet></router-outlet>
<toaster-container></toaster-container>